<template>
    <VModal
        :name="name"
        height="auto"
        width="100%"
        :scrollable="true"
        :click-to-close="false"
        @opened="opened"
        @closed="closed"
    >
        <div class="relative h-screen pt-16 pb-40 overflow-scroll transition-all bg-white w-80">
            <button
                v-if="closable"
                aria-label="Close drawer"
                class="absolute top-0 right-0 w-6 h-6 mt-6 mr-6 cursor-pointer text-grey-500"
            >
                <!-- prettier-ignore -->
                <svg
                    viewBox="0 0 413.348 413.348" xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    focusable="false"
                    @click="close">
                    <path fill="currentColor" d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z" />
                </svg>
            </button>
            <slot />
        </div>
    </VModal>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        mobileOnly: {
            type: Boolean,
            default: false
        },
        closable: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        close() {
            this.$modal.hide(this.name);
            this.$emit('close');
        },

        opened() {
            if (this.mobileOnly) {
                document.body.classList.add('scroll-initial-lg');
            }
        },

        closed() {
            if (this.mobileOnly) {
                document.body.classList.add('scroll-initial-lg');
            }
        }
    }
};
</script>

<style scoped>
/* purgecss start ignore */
::v-deep .v--modal {
    @apply flex items-center justify-start bg-transparent z-30;
}

::v-deep .v--modal-box {
    @apply top-0 shadow-none !important;
}

::v-deep .scroll {
    overflow: initial;
    width: initial;
}
/* purgecss end ignore */
</style>
